import QunjielongAccount from "./-qunjielongAccount";
import { getSystemDefaultPath, isSuperAdminUser } from "@/stores/authStore";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/system/qunjielongAccount")({
  beforeLoad: () => {
    if (!isSuperAdminUser()) {
      throw redirect({ to: getSystemDefaultPath() });
    }
  },
  staticData: {
    menuLabel: "群接龙账号",
    showInMenu: true,
    menuGroup: "/system",
    menuOrder: 2,
    requireSuperAdmin: true,
  },
  component: QunjielongAccount,
});
